import Vue from 'vue';
import Vuex from 'vuex';
import { authmodule } from './modules/authmodule';
import { countrymodule } from './modules/countrymodule';
import { maintenancemodule } from './modules/maintenancemodule';
import { regionmodule } from './modules/regionmodule';
import { postcodemodule } from './modules/postcodemodule';
import { fileuploadmodule } from './modules/fileuploadmodule';
import { companysearchmodule } from './modules/companysearchmodule';
import { quicksearchmodule } from './modules/quicksearchmodule';
import { sectormodule } from './modules/sectormodule';
import { subsectormodule } from './modules/subsectormodule';
import { siccodemodule } from './modules/siccodemodule';
import { companysearchresultmodule } from './modules/companysearchresultmodule';
import { tablelayoutmodule } from './modules/tablelayoutmodule';
import { companymodule } from './modules/companymodule';
import { exportmodule } from './modules/exportmodule';
import { filemodule } from './modules/filemodule'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		authmodule,
		countrymodule,
		regionmodule,
		postcodemodule,
		fileuploadmodule,
		companysearchmodule,
		quicksearchmodule,
		subsectormodule,
		sectormodule,
		siccodemodule,
		companysearchresultmodule,
		tablelayoutmodule,
		companymodule,
		exportmodule,
		maintenancemodule, 
		filemodule
	}
});
